import AddMeasurementButton from 'app/admin/common/component/AddMeasurementButton';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import PiAfEventReaderService from '../service/PiAfEventReaderService';
import PiAfEventReaderTableService from '../service/PiAfEventReaderTableService';

const config = {
	key: 'piAfEventReaderTable',
	topic: 'piAfEventReader',
	service: PiAfEventReaderTableService,
	editFormState: item => `/pi-af-event-reader/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	rowButtonList: [
		{ key: 'addMeasurement', component: AddMeasurementButton, service: PiAfEventReaderService }
	],
	columns: [
		{ key: 'name' },
		{ key: 'piConnection.name' },
		{ key: 'database' },
		{ key: 'templateName' }
	]
};

function PiAfEventReaderTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('piAfEventReaderTable', reducer('piAfEventReaderTable'))(PiAfEventReaderTable);
